import { Paragraph } from '@pb/shared/ui/atoms/paragraph';
import { Heading } from '@pb/shared/ui/atoms/heading';
import { getAppEnvironmentSettings } from '@pb/apps/offers/services/environment';
import { TAmlInformationProperties } from './aml-information.types';
import {
    StyledContainer,
    StyledHorizontalLine,
} from './aml-information.styled';

export function AmlInformation({
    showHorizontalRule = false,
}: TAmlInformationProperties) {
    const { showLTLUpdatedProofOfFundsWording } = getAppEnvironmentSettings();

    return (
        <StyledContainer>
            {showHorizontalRule ? <StyledHorizontalLine color="grey4" /> : null}
            <Heading
                id="amlDisclaimerTitle"
                level={3}
                size="xxsmall"
                marginTop="regular"
            >
                {showLTLUpdatedProofOfFundsWording
                    ? 'Anti-money laundering and proof of funds checks'
                    : 'Information on Anti-Money Laundering checks'}
            </Heading>
            <Paragraph marginTop="small" color="grey6" small>
                {showLTLUpdatedProofOfFundsWording
                    ? 'We’re required by law to carry out anti-money laundering and proof of funds checks on all those buying a property.'
                    : 'We’re required by law to carry out Anti-Money Laundering checks on all those buying a property.'}
            </Paragraph>
            <Paragraph color="grey6" small>
                It’s our responsibility to ensure checks are carried out
                correctly and for ongoing monitoring. We will contact you once a
                seller has accepted your offer on their property to complete
                these checks.
            </Paragraph>
            <Paragraph color="grey6" small>
                {showLTLUpdatedProofOfFundsWording
                    ? 'These checks cost a non-refundable payment of £80 (incl. VAT). This covers collecting the relevant data, manual checks and monitoring. You’ll need to pay this and complete anti-money laundering and proof of funds checks before we issue you a memorandum of sale.'
                    : 'These checks cost a non-refundable payment of £80 (incl. VAT). This covers collecting the relevant data, manual checks and monitoring. You’ll need to pay this to Lifetime Legal and complete all Anti-Money Laundering checks before we issue you a Memorandum of Sale.'}
            </Paragraph>
        </StyledContainer>
    );
}
